module.exports = __webpack_public_path__ + "static/media/massive_star_btype.6baed5cd.png";